// extracted by mini-css-extract-plugin
module.exports = {"v-application":"Table_v-application_l90i-","text-h1":"Table_text-h1_36Gyo","text-h2":"Table_text-h2_3i3tO","table":"Table_table_3IdM_","sticky_cells":"Table_sticky_cells_3AXag"};